import { Provider } from '@angular/core';
import { AddressesApi } from './api/addresses.api';
import { AuthApi } from './api/auth.api';
import { BranchApi } from './api/branch.api';
import { CatalogApi } from './api/catalog.api';
import { OrdersApi } from './api/orders.api';
import { OrgApi } from './api/org.api';
import { PaymentsApi } from './api/payments.api';
import { ProfileApi } from './api/profile.api';
import { SettingsApi } from './api/settings.api';
import { SiteApi } from './api/site.api';
import { AddressesHttpApi } from './http/addresses-http.api';
import { AuthHttpApi } from './http/auth-http.api';
import { BranchHttpApi } from './http/branch-http.api';
import { CatalogHttpApi } from './http/catalog-http.api';
import { OrdersHttpApi } from './http/orders-http.api';
import { OrgHttpApi } from './http/org-http.api';
import { PaymentsHttpApi } from './http/payments-http.api';
import { ProfileHttpApi } from './http/profile-http.api';
import { SettingsHttpApi } from './http/settings-http.api';
import { SiteHttpApi } from './http/site-http.api';

export function provideApi(): Provider[] {
  return [
    { provide: SiteApi, useClass: SiteHttpApi },
    { provide: CatalogApi, useClass: CatalogHttpApi },
    { provide: OrdersApi, useClass: OrdersHttpApi },
    { provide: AuthApi, useClass: AuthHttpApi },
    { provide: OrgApi, useClass: OrgHttpApi },
    { provide: AddressesApi, useClass: AddressesHttpApi },
    { provide: BranchApi, useClass: BranchHttpApi },
    { provide: ProfileApi, useClass: ProfileHttpApi },
    { provide: PaymentsApi, useClass: PaymentsHttpApi },
    { provide: SettingsApi, useClass: SettingsHttpApi },
  ];
}
